import { Base, createApp, importWhenVisible } from '@studiometa/js-toolkit';
import { Accordion, Figure, ModalWithTransition, Slider } from '@studiometa/ui';
import { isDev } from './config.js';

/**
 * App class.
 */
class App extends Base {
  /**
   * App config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'App',
    log: isDev(),
    components: {
      Slider,
      Accordion,
      Figure,
      Modal: ModalWithTransition,
      Plan: (app) => importWhenVisible(() => import('./components/Plan.js'), 'Plan', app),
      Video: (app) => importWhenVisible(() => import('./components/Video.js'), 'Video', app),
    },
  };
}

export default createApp(App, document.body);
